.avatar {
  --size: 40px;
  display: inline-flex;
  vertical-align: middle;
  aspect-ratio: 1/1;
  width: var(--size);
  height: var(--size);
  background: var(--blue);
  color: var(--white);
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  font-size: 4ch;
  overflow: hidden;

  &[data-size="xs"] {
    --size: 30px;
  }

  &[data-size="m"] {
    --size: 60px;
  }

  &[data-size="l"] {
    --size: 100px;
  }
}

.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
